import _ from 'lodash';
import formatValue from "./FormatValue";

const makePivotColumns = (data = [], rows, values, pivotColumns, columns, pivot = {}) => {
    let newColumns = [];
    rows.forEach(row => {
        newColumns.push({...row})
    });
    const {grandTotal = {}} = pivot
    const {column = {}} = grandTotal;
    //spread data by columns
    if (pivotColumns && pivotColumns.length > 0 && data.length > 0) {
        let pivColumns = [];
        pivotColumns.forEach((pivCol, index) => {
            let newRows = _.uniqBy(data, pivCol.name);
            newRows.forEach(newRow => {
                Object.keys(newRow).forEach(key => {
                    if (pivCol.name === key) {
                        let getColumns = getSpreadColumn(columns, key, newRow[key], values, index);
                        pivColumns.push(getColumns)
                    }
                })
            });
        });

        //add grand total (last column)
        !column.hidden &&  pivColumns.push({label: 'Total', name: 'grandTotal', type: 'integer'});

        //push columns
        newColumns.push(...pivColumns)
    } else {
        //only by values
        values.forEach((value, index) => {
//            console.log(value)
            let getColumns = getColumn(columns, value);
            newColumns.push({...getColumns, name: getColumns.name + index})
        });
    }
    return newColumns
};


function getColumn(columns, value) {
    let fullColumn = {};

    if(!value) return
    columns.forEach(col => {
        if (col.name === value.field) {
            fullColumn = {...col, label: value.label}
        }
    });
    return fullColumn;
}

function getSpreadColumn(columns, value, label = "", pivotValues, pivotColIndex) {
    let pivotValueCol = pivotValues.length > 0 && getColumn(columns, pivotValues[pivotColIndex]);
    //get first pivotValue value, to have type of column
    let type = pivotValueCol ? pivotValueCol.type : 'number';
    let format = pivotValueCol ? pivotValueCol.format : '';
    let fullColumn = {};
    columns.forEach(col => {
        if (col.name === value) {
            fullColumn = {...col, label: formatValue(label, col.type, col.mask), name: label, type: type, format}
        }
    });
    return fullColumn;
}

export {
    makePivotColumns
};